import styled from "@emotion/styled"
import { PInlineNotification, PLinkPure } from "@porsche-design-system/components-react"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { useDealerAppRoutes } from "#src/common/routes/useDealerAppRoutes"
import { Markdown } from "../markdown/Markdown"

const messages = defineMessages({
	explanation: {
		defaultMessage:
			"Due to technical difficulties open campaigns displayed in the Finder Dealer App can currently be missing or outdated. Until we resolve that issue it is now possible to sell and deliver vehicles regardless of campaigns.\n" +
			"**Please check PCSS for open campaigns before you sell or deliver this vehicle.**",
		id: "wwsCampaignWarning.explanation",
	},
	pcssLink: {
		defaultMessage: "Show in PCSS",
		id: "wwsCampaignWarning.pcssLink",
	},
})

interface WwsCampaignWarningProps {
	vin: string
}

export const WwsCampaignWarning = ({ vin }: WwsCampaignWarningProps) => {
	const { formatMessage } = useIntl()
	const routes = useDealerAppRoutes()

	return (
		routes?.external && (
			<StyledInlineNotification state="warning" dismissButton={false}>
				<Markdown value={formatMessage(messages.explanation)} />

				<PLinkPure href={routes.external.pcss.url(vin)} icon="external" alignLabel="start" target="_blank">
					<FormattedMessage {...messages.pcssLink} />
				</PLinkPure>
			</StyledInlineNotification>
		)
	)
}

const StyledInlineNotification = styled(PInlineNotification)`
	margin-top: ${spacingStaticMd};
`
